import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledMakeModelYear,
  StyledPendingMake,
  StyledPendingMakeModel,
  StyledPendingModel,
  StyledPendingYear
} from './Styles';

const propTypes = {
  onCardClick: PropTypes.func.isRequired,
  tradeSummary: PropTypes.shape({
    year: PropTypes.number.isRequired,
    make: PropTypes.shape({
      name: PropTypes.string,
      displayName: PropTypes.string
    }),
    model: PropTypes.shape({
      name: PropTypes.string,
      displayName: PropTypes.string
    })
  }).isRequired
};

const Title = ({ tradeSummary, testId, onCardClick }) => {
  const { year, make, model } = tradeSummary;

  return (
    <StyledMakeModelYear data-testid={testId} onClick={onCardClick}>
      <StyledPendingYear
        data-testid={`pendinglist-year-${tradeSummary?.id}`}
        className="notranslate"
      >
        {year}
      </StyledPendingYear>
      <StyledPendingMakeModel>
        <StyledPendingMake
          data-testid={`pendinglist-make-${tradeSummary?.id}`}
          className="notranslate"
        >
          {make.name || make?.displayName}
        </StyledPendingMake>
        <StyledPendingModel
          data-testid={`pendinglist-model-${tradeSummary?.id}`}
          className="notranslate"
        >
          {model.name || model?.displayName}
        </StyledPendingModel>
      </StyledPendingMakeModel>
    </StyledMakeModelYear>
  );
};

Title.propTypes = propTypes;

export default Title;
